module.exports = __webpack_public_path__ + "static/media/correct.077cfc49.svg";